import React from "react";

const Ticket = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-ticket"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-ticket"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M21,15V3a3,3,0,0,0-3-3H14V1a2,2,0,0,1-4,0V0H6A3,3,0,0,0,3,3V15H7v2H3v7h7V23a2,2,0,0,1,4,0v1h7V17H17V15Zm-7,2H10V15h4Z" />
    </svg>
  );
};

export default Ticket;
